import axios from '@/api/axios'

const createArticle = (athlete) => {
  return axios.post('/athletes', athlete)
}

const getArticles = () => {
  return axios.get('/athletes')
}

const getArticlesList = (params) => {
  return axios.get('/athletes/list', {params})
}

const getArticle = (id) => {
  return axios.get(`/athletes/${id}`)
}

const updateAthlete = (id, athleteInput) => {
  return axios.put(`/athletes/${id}`, athleteInput)
}

const deleteAthlete = (id) => {
  return axios.delete(`/athletes/${id}`)
}

const verifiedAthlete = ({athleteId, params}) => {
  return axios.put(`/athletes/verified/${athleteId}`, params)
}

const activateAthlete = (athleteId, params) => {
  return axios.put(`athletes/school/activate/${athleteId}`, null, {params})
}

const deactivateAthlete = (athleteId, params) => {
  return axios.put(`athletes/school/deactivate/${athleteId}`, null, {params})
}

const athleteIsBlocked = ({athleteId, isBlocked}) => {
  return axios.put(`athletes/${athleteId}/isBlocked`, {isBlocked})
}

export default {
  createArticle,
  getArticles,
  getArticlesList,
  getArticle,
  updateAthlete,
  deleteAthlete,
  verifiedAthlete,
  activateAthlete,
  deactivateAthlete,
  athleteIsBlocked,
}
